import Vue from 'vue';
import VueRouter from 'vue-router';
import storage from '@sim/services/storage';
import SimStep1 from '@sim/components/SimStep1/SimStep1.vue';
import SimStep2 from '@sim/components/SimStep2/SimStep2.vue';
import SimStep3 from '@sim/components/SimStep3/SimStep3.vue';
import SimStep4 from "@sim/components/SimStep4/SimStep4.vue";
import SimStep5 from "@sim/components/SimStep5/SimStep5.vue";
import SimStep6 from "@sim/components/SimStep6/SimStep6.vue";

Vue.use(VueRouter);

const root_element = document.getElementById('sim-registration');

storage.save('locale', root_element.getAttribute('data-locale'), true);

let prefix = storage.get('locale', true) ? '/'+storage.get('locale', true) : '/de';

const routes = [
    {
        path: prefix + '/sim-registration/1',
        component: SimStep1,
        name: 'sim-step-1',
        meta: { stepNumber: '1' },
    },
    {
        path: prefix + '/sim-registration/2',
        component: SimStep2,
        name: 'sim-step-2',
        meta: { stepNumber: '2' },
    },
    {
        path: prefix + '/sim-registration/3',
        component: SimStep3,
        name: 'sim-step-3',
        meta: { stepNumber: '3' },
    },
    {
        path: prefix + '/sim-registration/4',
        component: SimStep4,
        name: 'sim-step-4',
        meta: { stepNumber: '4' },
    },
    {
        path: prefix + '/sim-registration/5',
        component: SimStep5,
        name: 'sim-step-5',
        meta: { stepNumber: '5' },
    },
    {
        path: prefix + '/sim-registration/6',
        component: SimStep6,
        name: 'sim-step-6',
        meta: { stepNumber: '6' },
    }
];


const router = new VueRouter({
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    base: process.env.BASE_URL,
    linkExactActiveClass: 'active-link',
    mode: 'history',
    routes,
});

export default router;
